const DropdownMenuItem = ({
  children,
  key,
  className,
  onClick,
}: {
  children: React.ReactNode;
  key?: string;
  className?: string;
  onClick?: (e: any) => void;
}) => (
  <button
    key={key}
    onClick={(e) => onClick!(e)}
    className={
      'flex w-full items-center gap-2 px-4 py-2 text-left text-sm hover:bg-brandLight/30 ' +
      className
    }
  >
    {children}
  </button>
);

export default DropdownMenuItem;
